import { computed, ref } from 'vue';
import i18n from '@/i18n/index';

export const createTrackingDomainsModule = () => {
  const trackingDomains = ref({
    data: [] as TrackingDomain[],
    isUploaded: false,
  });

  const populateTrackingDomainsCache = (payload: TrackingDomain[]) => {
    trackingDomains.value.data = payload;
    trackingDomains.value.isUploaded = true;
  };

  const resetTrackingDomains = () => {
    trackingDomains.value.data = [];
    trackingDomains.value.isUploaded = false;
  };

  const trackingDomainsObject = computed(() =>
    trackingDomains.value.data.reduce<Record<string, TrackingDomain>>((accumulator, item) => {
      accumulator[item.id] = item;
      return accumulator;
    }, {}),
  );

  const trackingDomainsWithAccountDefault = computed((): TrackingDomain[] => [
    {
      campaignId: '',
      campaignNameFull: '',
      custom: false,
      domain: String(i18n.global.t('Account default')),
      httpsAvailable: false,
      id: '',
      userId: '',
      workspaceIds: [],
    } as TrackingDomain,
    ...trackingDomains.value.data,
  ]);

  const reset = () => {
    resetTrackingDomains();
  };

  return {
    state: {
      trackingDomains,
      populateTrackingDomainsCache,
      resetTrackingDomains,
      trackingDomainsObject,
      trackingDomainsWithAccountDefault,
    },
    reset,
  };
};
